<template>
  <v-container>
    <v-form
      ref="formclp"
      v-model="validForm"
    >
      <v-card
        color="#efefef"
        class="ma-0 mb-5 "
      >
        <v-row
          justify="center"
          class="pa-4"
        >
          <v-col
            cols="12"
          >
            <v-text-field
              ref="desrif"
              v-model="steporder.desrif"
              class="uppercase-text"
              autofocus
              outlined
              label="Riferimento"
              hint="Quanto indicato come 'riferimento' sarà utilizzato come identificativo dell'ordine abbinato al numero risultante al termine del processo in corso"
              placeholder=""
              required
              :rules="[rules.required,rules.min]"
              @blur="$set(steporder,'desrif',steporder.desrif?.toUpperCase())"
            />
          </v-col>
        </v-row>
        <v-row class="pa-4">
          <v-col
            class="  text-no-wrap"
          >
            <v-row
              no-gutters
              align="start"
            >
              <v-img
                :src="lens.desmod!='NN' ? `./img/FRM/${lens.desmod}.png` : './img/noimage.jpg'"
                :lazy-src="'./img/noimage.jpg'"
                max-width="90"
                contain
                class="mb-2 mr-2 pa-0"
              />
              <v-text-field
                v-model="lens.desmod"
                label="Cod. modello"
                outlined
                readonly
                :rules="[rules.required]"
                required
                @click="showForme = true;"
              />
            </v-row>
            <v-row
              v-if="nolens"
              class="ma-0 blue--text"
              style="margin:-25px 0 0 0 !important;"
              @click="showForme=true"
            >
              <v-col
                cols="auto"
                style="cursor:pointer"
              >
                <v-icon>mdi-message-bulleted</v-icon> {{ lens.nolens_detail }}
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="  text-no-wrap"
          >
            <v-select
              ref="calibro"
              v-model="lens.calibr"
              :items="rangeCalibro"
              :disabled="!lens.desmod"
              label="Calibro"
              :outlined="!!lens.desmod"
              :rules="!!lens.desmod ? [rules.obbligatorio] : []"
              hint="Inserire il valore maggiorato di +3 mm rispetto l`occhiale"
              persistent-hint
            />
          </v-col>
        </v-row>
      </v-card>
    </v-form>
    <v-btn
      color="primary"
      :disabled="!validForm "
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="$emit('prevStep', 0)"
    >
      Indietro
    </v-btn>

    <v-dialog
      v-model="showForme"
      scrollable
      max-width="800"
    >
      <v-card>
        <v-col>
          <v-row no-gutters>
            <span class="text-h2 font-weight-light">Modello/Forma Lenti </span>
            <v-spacer />
            <v-btn
              v-if="!nolens"
              x-small
              fab
              @click="showForme = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-divider />
        <v-card-subtitle>
          <v-col cols="12">
            <v-checkbox
              v-model="nolens"
              label="lente non in elenco"
              @change="setDesmod"
            >
              <template v-slot:label>
                <span :class="nolens?'text-h3 font-weight-light black--text':'text-h3 font-weight-light grey--text'">Lente non in elenco</span>
              </template>
            </v-checkbox>
            <v-row v-if="nolens">
              <v-col cols="12">
                <v-textarea
                  v-model="lens.nolens_detail"
                  outlined
                  label="Descrizione caratteristiche e dettagli lente"
                />
              </v-col>
            </v-row>
            <v-text-field
              v-if="!nolens"
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              placeholder="cerca modello lente"
              single-line
              hide-details
              outlined
            />
          </v-col>
        </v-card-subtitle>

        <v-card-text>
          <!-- {{ listalenti }} -->
          <v-data-table
            v-if="!nolens"
            fixed-header
            mobile-breakpoint="0"
            disable-pagination
            hide-default-footer
            dense
            :items="listalenti"
            :headers="headers"
            :search="search"
            item-key="id"
            @click:row="lensClick"
          >
            <template
              v-slot:item.modello="{item}"
            >
              <span class="text-h2 font-weight-light">{{ item.modello }}</span>
            </template>
            <template
              v-slot:item.forma="{item}"
            >
              <v-img
                :src="`./img/FRM/${item.modello}.png`"
                :lazy-src="'./img/noimage.jpg'"
                max-width="150"
                contain
                class="ma-2"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions v-if="nolens">
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="lens.nolens_detail=null; nolens = false"
          >
            Annulla
          </v-btn>
          <v-btn
            color="primary"
            :disabled="lens.nolens_detail==null || lens.nolens_detail.trim()==''"

            @click="showForme = false"
          >
            Conferma
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Step1',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        loading: false,
        steporder: {},
        validForm: true,
        lens: { nolens_detail: null },
        procedura: {},
        nolens: false,
        dittalenti: [],
        listalenti: [],
        listapromo: [],
        rangeCalibro: [],

        headers: [
          { text: '', value: 'modello', align: 'right text-caption', width: '30%' },
          { text: '', value: 'forma', align: 'left text-caption', sortable: false },

        ],
        search: '',
        showForme: false,
        rules: {
          obbligatorio: value => !!value || 'Inserire il valore maggiorato di +3 mm rispetto l`occhiale.',
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
          signed: v => (!v || /^[+-]\d*\.?\d*$/.test(v)) || 'E` richiesto il segno + o -',
          range: (min, max) => (v) => {
            if (!v) {
              return true
            }
            var num = parseFloat(v)
            return (num >= min && num <= max) || `Richiesto valore tra ${min} e ${max}`
          },
          stepper: (step) => (v) => {
            if (!v) {
              return true
            }
            var num = parseFloat(v)

            const tolerance = 0.015
            var valore = Math.abs(num % step).toFixed(10)
            console.log(num, step, valore)
            if (valore < tolerance) {
              valore = 0
            }
            // console.log(40 % 0.01)
            // due to floating-point precision issues, the result is not exactly zero
            return (valore === 0) || `Richiesto multiplo di ${step}`
          },
          requiredOn: (field) => (v) => {
            if (this.$refs[field] && this.$refs[field]?.value) {
              return !!v || `Richiesto un valore perchè ${field.substr(3).toUpperCase()} non e' vuoto`
            }
            return true
          },
          requiredIf: (vero) => (v) => {
            if (vero) {
              return !!v || 'Valore richiesto'
            }
            return true
          },
        },
        menu_data_lenti: false,
        dataord_lenti: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      }
    },

    computed: {
      ...mapState(['auth', 'order', 'carnet', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      linea () {
        if (!this.order.codlin) {
          return { codlin: 0, label: '' }
        }
        return this.clidata.anlin.filter(item => item.codlin === this.order.codlin)[0]
      },
    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    mounted () {
      this.initData(this.step)
      this.load_listalenti()
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          console.log('load', this.$options.name)
          this.steporder = Object.assign({}, this.order)
          if (this.steporder.lens) {
            this.lens = this.steporder.lens
            if (this.lens.desmod !== '') { this.lensClick({ init: true, modello: this.lens.desmod, calibro: this.lens.calibr }) }
          }
          if (!this.steporder.step) {
            this.steporder.step = this.step
          }
        }
      },

      load_listalenti () {
        this.loading = true
        engine.get_listalenti(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listalenti = result.data
          })
          .catch((errore) => {
            console.log('get_listalenti err: ', errore)
          }).finally(() => { this.loading = false })
      },
      validate () {
        this.$refs.formclp.validate()
      },
      reset () {
        this.$refs.formclp.reset()
      },
      resetValidation () {
        this.$refs.formclp.resetValidation()
      },
      lensClick (item) {
        // linea: SWF
        this.setRangeCalibro(item.calibro)
        this.$set(this.lens, 'desmod', item.modello)
        this.$set(this.lens, 'calibr', null)
        if (item.init) { this.$set(this.lens, 'calibr', item.calibro) }

        this.$forceUpdate()
        this.showForme = false
      },
      setDesmod () {
        if (this.nolens) {
          this.$set(this.lens, 'desmod', 'NN')

          // linea SWF
          this.rangeCalibro = [43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57]

          this.$set(this.lens, 'calibr', null)
        }
      },
      setRangeCalibro (calibro) {
        // su clipon il calibro và maggiorato di 3
        calibro = +calibro + 3
        // creo range di -4, +4 a partire dal calibro base
        this.rangeCalibro = Array.from({ length: 9 }, (_, index) => parseInt(calibro) - 4 + index)
      },
      setDiamet (value) {
        this.$set(this.lens, 'diamet', value); this.validate(); this.$forceUpdate()
      },
      nextStep () {
        if (!this.validForm) { return }
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        this.steporder.lens = JSON.parse(JSON.stringify(this.lens))
        console.log('steporder', this.steporder)
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
    },
  }
</script>
